import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';
import { gameListJson } from '@/components/ElectronLayout/ElectronHead/server';

export interface PlayGameState {
  gameList: gameListJson[];
}

const localGameInfo = LocalStore.getValue<PlayGameState>('SET_RECENT_PALY_GAME') || {};

export const liveHeadInfo: PlayGameState = {
  gameList: [],
  ...localGameInfo
};

export const setRecentlyPlayGame: (payload: PlayGameState) => IAction<PlayGameState> = (payload: PlayGameState) => ({
  type: 'setRecentlyPlayGame',
  payload
});

const liveReducer: Reducer<PlayGameState, IAction<any>> = (state = liveHeadInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setRecentlyPlayGame':
      LocalStore.setValue('SET_RECENT_PALY_GAME', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default liveReducer;
